module.exports = __webpack_public_path__ + "img/boton_eliminar.5fe8ca49.svg";